import React from 'react';
import FocusBlock from '../c-focus-block';

const FocusContainerBlock = (props) => {
  return props.MainContent.length === 1 ? (
    props.MainContent.map((block, index) => (
      <FocusBlock
        key={index}
        heading={block.Heading}
        description={block.Description}
        informationType={block.InformationType ?? block.Theme}
        link={block.LinkUrl ?? block.Url}
        linkText={block.LinkText}
        isFullWidth={true}
      />
    ))
  ) : (
    <div className='c-focus-container-block'>
      {props.MainContent.map((block, index) => (
        <FocusBlock
          key={index}
          heading={block.Heading}
          description={block.Description}
          informationType={block.InformationType ?? block.Theme}
          link={block.LinkUrl ?? block.Url}
          isFullWidth={false}
        />
      ))}
    </div>
  );
};

export default FocusContainerBlock;
